const MomentFormat = {
  DATE: 'YYYY-MM-DD',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  TIME: 'HH:mm',
  MONTH: 'MMMM',
  YEAR: 'YYYY',
  LOCALE_SHORT: 'L',
  LOCALE_LONG: 'LL',
  LOCALE_TIME: 'LT',
  LOCALE_SHORT_TIME: 'L LT',
  LOCALE_DATE_TIME: 'L LTS',
  LOCALE_DATE_TIME_12H_FORMAT_WITH_TIMEZONE: 'L LTS A (z)',
};

export default MomentFormat;
